import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQueryInput]' })
export class QueryInputDirective
{
  private aType: string;

  constructor(public template: TemplateRef<any>) { }

  /** Unique name for query input type. */
  @Input()
  public get queryInputType(): string { return this.aType; }
  public set queryInputType(value: string)
  {
    // If the directive is set without a type (updated from code), then this setter will
    // trigger with an empty string and should not overwrite the set value.
    if (!value) { return; }
    this.aType = value;
  }
}
